<template>
  <el-container class="container">
    <el-aside width="220px" class="aside">
      <div class="logo">
        <img src="https://painier.oss-cn-hangzhou.aliyuncs.com/painier/finally/background.png" alt="">
      </div>
      <!--<el-menu :default-active="url" class="aside-cont navbar" text-color="#666666" router :unique-opened="true">-->
      <!--&lt;!&ndash;:collapse="isCollapse"&ndash;&gt;-->
      <!--<template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">-->
      <!--<el-submenu :index="index+''" v-if="!item.leaf">-->
      <!--<template slot="title"><i :class="item.iconCls"></i><span>{{item.name}}</span></template>-->
      <!--<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden"-->
      <!--:class="netaddress==child.path?'is-active':''" @click="netaddress=child.path">{{child.name}}-->
      <!--</el-menu-item>-->
      <!--</el-submenu>-->
      <!--<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"-->
      <!--:class="netaddress==item.children[0].path?'is-active':''"-->
      <!--@click="netaddress=item.children[0].path"><i-->
      <!--:class="item.iconCls"></i><span>{{item.name}}</span></el-menu-item>-->
      <!--</template>-->
      <!--</el-menu>-->
      <el-menu :default-active="url" class="aside-cont navbar g-elmenu" text-color="#546a79" router
               :unique-opened="true" :collapse="isCollapse">
        <template v-for="(item,index) in $router.options.routes" v-if="!item.hidden&&$checkPermissions(item.permission)&&item.module == activeName" ><!--&&item.module == activeName-->
          <el-submenu :index="index+''" v-if="!item.leaf">
            <template slot="title">
              <i :class="item.iconCls+' '+((netaddress===item.children[0].path&&isCollapse)?'actived':'')"></i>
              <span>{{item.name}}</span>
            </template>
            <el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden&&$checkPermissions(child.permission)">
              {{child.name}}
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-if="item.leaf&&item.children.length>0&&$checkPermissions(item.permission)" :index="item.children[0].path"
                        :class="netaddress==item.children[0].path?'is-active':''">
            <i :class="item.iconCls"></i><span>{{item.name}}</span></el-menu-item>
        </template>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header flex-box" height="100px">
<!--        <div class="crumb-box flex-box">
          <span>当前位置：</span>
          <el-breadcrumb separator-class="el-icon-arrow-right" class="crumb">
            <el-breadcrumb-item v-for="item in $route.matched" :key="item.path" v-if="item.name">
              {{ item.name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>-->
        <div class="tabs-box  header-nav">
         <el-tabs v-model="activeName" @tab-click="handleClick" >
            <el-tab-pane label="商城管理" name="first" v-if="$checkPermissions('marketMenu')" ></el-tab-pane>
            <el-tab-pane label="服务管理" name="second" v-if="$checkPermissions('serviceMenu')"></el-tab-pane>
            <el-tab-pane label="结算管理" name="third" v-if="$checkPermissions('settlementMenu')" ></el-tab-pane>
            <el-tab-pane label="医生管理" name="fourth" v-if="$checkPermissions('doctorMenu')" ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="user-box flex-box">
          <el-button type="primary" @click="centerDialogVisible = true" style="margin-right: 40px">密码修改</el-button>
          <el-button type="primary" @click="loginout">退出登录</el-button>
          <!--<div class="help flex-box" style="margin-right: 20px;">
            <i class="iconfont icon-questionfill "></i>
            <b @click="centerDialogVisible = true" style="cursor:pointer">密码修改</b>
          </div>
          <div class="help flex-box">
            <i class="iconfont icon-questionfill "></i>
            <b @click="loginout" style="cursor:pointer">退出登录</b>
          </div>-->
        </div>
      </el-header>
      <el-main class="main">
     <!--   <keep-alive>
          <router-view v-if="$route.meta.keepAlive">
            &lt;!&ndash; 这里是会被缓存的视图组件，比如 page1,page2 &ndash;&gt;
          </router-view>
        </keep-alive>-->
        <router-view >
          <!-- 这里是不被缓存的视图组件，比如 page3 -->
        </router-view>
      </el-main>
    </el-container>
    <el-dialog
      title="修改密码"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <el-form ref="userform" :model="userform" label-width="120px" :rules="rules">
        <el-form-item label="用户名">
          <el-input v-model="userform.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model.trim="userform.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmpassword">
          <el-input v-model.trim="userform.confirmpassword" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="editPassword('userform')">确 定</el-button>
  </span>
    </el-dialog>
  </el-container>
</template>
<script>
  import * as getData from '../service/getData.js'

  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.userform.confirmpassword !== '') {
            this.$refs.userform.validateField('confirmpassword');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.userform.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        centerDialogVisible:false,
        isCollapse: false,
        username: '',
        active: '',
        netaddress: '',
        url: this.$route.path,
        userform:{
          username:'',
          password:'',
          confirmpassword:'',
          userId:'',
        },
        rules:{
          password:[
            { validator: validatePass, trigger: 'blur' },
          ],
          confirmpassword:[
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
        myPermission:{},
        activeName:'first'
      }
    },
    mounted() {
      this.username = sessionStorage['username'];
      this.urlRedirect(this.url);
      let user = JSON.parse(sessionStorage['user']);
      this.userform.username = user.adminUsername
      this.userform.userId = user.adminId
      this.myPermission = JSON.parse(sessionStorage['myPermission']);
      //console.log(this.$router.options.routes)
    },
    methods: {
      editPassword(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let  datas = {
              adminId:this.userform.userId,
              adminPassword:this.userform.password,
            }
            getData.changePassword(datas).then( res =>{
              if(res.data.rCode == 'success'){
                this.exit()
              }
              else{
                this.$message({
                  type: 'success',
                  message: res.data.msg
                });
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      exit(){
        getData.toLoginOut().then(res => {
          if (res.data.rCode == 'success') {
            sessionStorage.clear();
            this.$message({
              type: 'success',
              message: '修改密码成功！请重新登录！'
            });
            this.$router.replace('/login')
          }
        })
      },
      shows(path) {
        this.$store.state.localpath = path;
      },
      loginout() {
        this.$confirm('此操作将进行退出操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          getData.toLoginOut().then(res => {
            if (res.data.rCode == 'success') {
              sessionStorage.clear();
              this.$message({
                type: 'success',
                message: '退出成功!'
              });
              this.$router.replace('/login')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出操作'
          });
        });
      },
      urlRedirect(val) {
        var routerList = this.$router.options.routes;
        routerList.forEach((parent) => {
          if (parent.children) {
            parent.children.forEach((child, childIndex, children) => {
              if (child.path === val && child.hidden) {
                this.url = child.from;
                this.netaddress = children[0].path;
              } else if (child.path === val) {
                this.netaddress = children[0].path;
                this.url = child.path;
              }
            })
          }
        })
      },
      handleClick(tab, event) {
        console.log(tab, event);
      }
    },
    watch: {
      '$route'(val) {
        this.urlRedirect(val.path);
        console.log(this.netaddress + ':::' + this.url)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../assets/css/mixin';

  .container {
    width: 100%;
    height: 100%;
    background-color: #fff;
    .aside {
      text-align: center;
      .logo {
        width: 80px;
        height: 80px;
        margin: 0px auto;
        img{
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
    }
    .header {
      background-color: #fff;
      height: 100px;
      padding: 0 40px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      //border-bottom: 1px solid #CCCCCC;
      .crumb-box {
        width: 350px;
      }
      .user-box {
        width: 250px;
        padding-left: 100px;
        .user {
          @include sc(16px, #333333);
          .userimg-box {
            @include wh(60px, 60px);
            border-radius: 50%;
            overflow: hidden;
            margin-right: 19px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
        .help {
          @include sc(16px, #9196A6);
          margin-left: 62px;
          .icon-questionfill {
            @include sc(20px, #CDD2D6);
            margin-right: 10px;
          }
        }
      }
    }
    .aside {
      height: 100%;
      background-color: #fff;
      position: relative;
      z-index: 1;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, .1);
      .el-menu-item:hover {

      }
      .aside-cont {
        border-right: none;
        .el-menu-item {
          text-align: left !important;
          span {
            font-size: 16px;
            color: rgba(102, 102, 102, 1);
          }
          i {
            @include sc(26px, #cdd2d6);
            margin-right: 17px;
          }
          .icon-yemian {
            font-size: 22px;
          }
          .icon-mendian {
            font-size: 32px;
            margin-right: 15px;
            margin-left: -3px;
          }
          .icon-aixin {
            font-size: 24px;
            margin-left: 2px;
          }
          .icon-baogao {
            font-size: 22px;
            margin-left: 3px;
          }
          .icon-yonghu {
            font-size: 24px;
            margin-left: 2px;
          }
          &:hover {

          }
          &:focus {

          }
          &.is-active {
            position: relative;
            span {
              color: $green !important;
            }
            i {
              color: $green;
            }
            &:after {
              content: '';
              width: 4px;
              height: 30px;
              @include ct();
              right: 0;
              background-color: $green;
            }
          }
        }
      }

    }
    .main {
      //padding: 20px 0 0 20px;
      padding: 20px;
      overflow-x: scroll;
      box-sizing: border-box;
      height: calc(100% - 100px);
      box-shadow: inset 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .navbar .active {
      position: relative;
      span {
        color: $green !important;
      }
      i {
        color: $green !important;
      }
      &:after {
        content: '';
        width: 4px;
        height: 30px;
        @include ct();
        right: 0;
        background-color: $green;
      }
    }
    .navbar .inactive {
      span {
        color: rgb(102, 102, 102) !important;
      }
      i {
        color: #cdd2d6 !important;
      }
      &:after {
        background: none !important;
      }
      color: rgb(102, 102, 102) !important;
    }
  }

  .el-submenu .el-submenu__title .actived {
    color: $blue;
  }
</style>



// WEBPACK FOOTER //
// src/view/home.vue